import { APIFactory } from '../../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';
import {
  convertFromDiscountsResponseArrayToDiscountsDataArray,
  IDiscountsData,
  IDiscountsResponse,
} from '../../../ui-toolkit/discounts/types/IDiscounts';

export const getDiscountsAsync = async (orderId: string): Promise<IDiscountsData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IDiscountsResponse[]>(`/orders/v5/admin/${orderId}/discounts`)
    .then((response) => convertFromDiscountsResponseArrayToDiscountsDataArray(response.data))
    .catch(axiosErrorHandler);

export const updateDiscountsAsync = async (orderId: string, discountId: string): Promise<IDiscountsData> => {
  return getDiscountsAsync(orderId).then((discountsDataArr) => {
    const discount = discountsDataArr.find((discountData) => discountData.id === discountId);
    if (!discount) throw new Error('Unable to find matching discount');
    return discount;
  });
};
